import React from "react";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons";

import Card from "../common/card";
import { Row, Col } from "antd";
import "./styles/works.css";

const Works = () => {
	return (
		<div className="works">
			<Card
				icon={faBriefcase}
				title="Work"
				body={
					<div className="works-body">
						{/* <div className="work">
							<img
								src="./hackerone.png"
								alt="facebook"
								className="work-image"
							/>
							<div className="work-title">HackerOne</div>

							<div className="work-subtitle">
								Penetration Tester | Bug Bounty
							</div>
							<div className="work-duration">
								Jan 2022 - Jun 2022
							</div>
						</div> */}

						<div className="d-flex work">
							<img
								src="./hackerone.png"
								alt="facebook"
								className="work-image"
							/>
							<div>
								<div className="work-title">HackerOne</div>
								<Row className="d-flex justify-content-between work-row">
									<div className="work-subtitle">
										Penetration Tester | Bug Bounty
									</div>
									<div className="work-duration ">
										Jan 2022 - Jun 2022
									</div>
								</Row>
							</div>
						</div>
					</div>
				}
			/>
		</div>
	);
};

export default Works;
